enum EInvoiceType {
  EINVOICE = 'EINVOICE',
  DIGIPOST = 'DIGIPOST',
}

export default EInvoiceType;
